import {
  MAX_LENGTH_CUSTOMER_REFERENCE,
  MAX_LENGTH_LOADING_NOTE,
} from '../../../../common/fieldLengths';
import { customerReferencePlaceHolder } from '../../../../common/utils/customerUtils';
import { transformCustomer } from '../../../../common/utils/optionTransformers';
import { DetailsFieldCell } from '../../../../common-ui/details/DetailsFieldCell';
import { useCreateIntermodalFieldValue } from '../../../../services/intermodal/hooks/UseCreateIntermodalFieldValue';
import { useAllIntermodalCustomersAsOptions } from '../../../../services/intermodal/hooks/useAllIntermodalCustomersAsOptions';
import { CreateIntermodalValidationWrapper } from '../CreateIntermodalValidationWrapper';
import { CreateIntermodalDropdownField } from '../fields/CreateIntermodalDropdownField';
import { CreateIntermodalTextInputField } from '../fields/CreateIntermodalTextInputField';

export const CreateIntermodalDetailsSection = () => {
  const customerOptions = useAllIntermodalCustomersAsOptions();
  const multipleCustomers = customerOptions.length > 1;
  const customer = useCreateIntermodalFieldValue('customer');

  return (
    <>
      {multipleCustomers && (
        <CreateIntermodalValidationWrapper
          name={'customer'}
          renderField={isValid => (
            <DetailsFieldCell
              label={'Account'}
              renderField={id => (
                <CreateIntermodalDropdownField
                  id={id}
                  trackerCategory={'IntermodalCreate'}
                  name={'customer'}
                  options={customerOptions}
                  transformOption={transformCustomer}
                  isValid={isValid}
                />
              )}
            />
          )}
        />
      )}
      <DetailsFieldCell
        label={'Customer reference'}
        renderField={id => (
          <CreateIntermodalTextInputField
            id={id}
            trackerCategory={'IntermodalCreate'}
            maxLength={MAX_LENGTH_CUSTOMER_REFERENCE}
            name={'customerReference'}
            placeholder={customerReferencePlaceHolder(customer)}
          />
        )}
      />
      <DetailsFieldCell
        label={'Loading note'}
        renderField={id => (
          <CreateIntermodalTextInputField
            id={id}
            maxLength={MAX_LENGTH_LOADING_NOTE}
            name={'loadingNote'}
            trackerCategory={'IntermodalCreate'}
          />
        )}
      />
    </>
  );
};
